<div class="projects-section">
  <app-tutorial-video-widget
    screenId="manage-approvals"
    title="Manage Approval walkthrough"
    teaserDescription="Watch a quick walkthrough of this screen."
    storageKey="manage-approval-tutorial-seen"
    teaserPosition="bottom-left"
    launcherPosition="bottom-left"
    [autoPlaySequence]="userWorkflowTutorialSequence"
    [allowLauncherDismiss]="true">
  </app-tutorial-video-widget>

  <div class="section-head-row-new">
    <h2 class="section-title">Manage Approval</h2>
    <span class="filter-chip" *ngIf="projects && projects.length > 0">RRE Queue</span>
  </div>

  <div class="empty-state" *ngIf="isLoading">
    <div class="empty-state-icon-wrap">
      <mat-icon class="empty-icon">hourglass_empty</mat-icon>
    </div>
    <h3 class="empty-title">Loading...</h3>
    <p class="empty-message">Fetching your pending approvals...</p>
  </div>

  <div class="empty-state" *ngIf="!isLoading && (!projects || projects.length === 0)">
    <div class="empty-state-icon-wrap">
      <mat-icon class="empty-icon">pending_actions</mat-icon>
    </div>
    <h3 class="empty-title">No Pending RRE Approvals</h3>
    <p class="empty-message">There are currently no projects awaiting your review.</p>
  </div>

  <div class="projects-list" *ngIf="projects && projects.length > 0">
    <div class="project-card" *ngFor="let project of projects">
      <div class="project-header project-header-stack">
        <div class="project-title-group">
          <!-- <h3 class="project-name">{{ project.project_name }}</h3> -->
           <a class="project-name-link" (click)="viewProject(project.project_details_id, project.department_id)">{{ project.project_name
                      }}</a>
        </div>
      </div>
      <div class="project-details">
        <div class="detail-item">
          <span class="detail-label">Collection Name</span>
          <span class="detail-value">{{ project.collection_name || project.collection || 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Sub-Collection</span>
          <span class="detail-value">{{ getSubCollection(project.sub_collection_name) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Due Date</span>
          <span class="detail-value">{{ formatDate(project.due_date) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Status</span>
          <span class="detail-value">
            <span class="status-badge" [ngClass]="getStatusBadgeClass(project.sub_task_status)">
              {{ project.sub_task_status || 'N/A' }}
            </span>
          </span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Contact Person</span>
          <span class="detail-value">{{ project.contact_person || project.contactPerson || 'N/A' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{ getAssignmentLabel(project) }}</span>
          <span class="detail-value">{{ getAssignedName(project) }}</span>
        </div>
      </div>

      <div class="due-progress-wrap" [ngClass]="getDueState(project)">
        <div class="due-progress-meta">
          <span class="due-progress-label">Timeline</span>
          <span class="due-progress-text">{{ getDueLabel(project) }}</span>
        </div>
        <div class="due-progress-track">
          <div class="due-progress-bar" [style.width.%]="getDueProgress(project)"></div>
        </div>
      </div>

      <button class="btn btn-sm btn-outline-primary"
        (click)="viewProject(project.project_details_id, project.department_id)">
        <mat-icon>visibility</mat-icon> View Project
      </button>
    </div>
  </div>

</div>